<template>
  <div class="wtxh-footer">
    <div class="wtxh-footer-content">
      <div class="wtxh-footer-top">
        <div class="wtxh-footer-logo">
          <img
            class="logo-img"
            src="@/assets/wthd-logo2.png"
            alt="中国职工文体协会 微电影短视频分会"
          />
        </div>
        <ul class="wtxh-footer-nav" v-if="navigation && navigation.length">
          <li
            v-for="item in navigation"
            :key="item.name"
            @click.stop="goNext(item)"
          >
            {{ item.name }}
          </li>
        </ul>
      </div>
      <div class="wtxh-footer-divider"></div>
      <div class="wtxh-footer-bottom">
        <span class="footer-text-item">技术支持：中工科创</span>
        <span class="footer-text-item">Copyright © 2023-2026 kskstudy.com All Rights Reserved</span>
        <span class="footer-text-item"
          >京ICP备<a
            href="https://beian.miit.gov.cn/"
            target="_blank"
            rel="noopener noreferrer"
            >京ICP备16012224号</a
          ></span
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BottomWtxh",
  props: {
    logo: String,
  },
  data() {
    return {
      navigation: [],
    };
  },
  mounted() {
    let nav = localStorage.getItem("nav_zgwt");
    if (nav) {
      this.navigation = JSON.parse(nav);
    }
  },
  methods: {
    goNext(data) {
      if (data.url.includes("http")) {
        window.open(data.url);
        return;
      }
      let set_info = JSON.parse(localStorage.getItem("siteInfo"));
      if (set_info) {
        document.getElementById("titleName").innerHTML =
          data.name + " - " + set_info.name;
      }
      localStorage.setItem("menuName", data.name);
      localStorage.setItem("activeMenuUrl", data.url);
      let url = data.url.startsWith("/") ? data.url : "/" + data.url;
      this.$router.push(url).catch((err) => {
        if (err.name !== "NavigationDuplicated") {
          throw err;
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.wtxh-footer {
  width: 100%;
  background-color: #1d1d1d;
}
.wtxh-footer-content {
  width: 1200px;
  margin: 0 auto;
  padding: 34px 0 21px;
  box-sizing: border-box;
}
.wtxh-footer-top {
  display: flex;
  align-items: center;
  height: 63px;
}
.wtxh-footer-logo {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  .logo-img {
    width: 294px;
    height: 63px;
    object-fit: contain;
  }
}
.wtxh-footer-nav {
  display: flex;
  align-items: center;
  margin-left: 66px;
  li {
    font-family: "PingFangSC-Regular", "PingFang SC", sans-serif;
    font-weight: 400;
    font-size: 18px;
    color: rgba(255, 255, 255, 0.54);
    line-height: 25px;
    white-space: nowrap;
    cursor: pointer;
    margin-right: 50px;
    transition: color 0.2s;
    &:last-child {
      margin-right: 0;
    }
    &:hover {
      color: rgba(255, 255, 255, 0.85);
    }
  }
}
.wtxh-footer-divider {
  width: 100%;
  height: 1px;
  background-color: rgba(255, 255, 255, 0.2);
  margin-top: 40px;
}
.wtxh-footer-bottom {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 20px;
  font-family: "PingFangSC-Regular", "PingFang SC", sans-serif;
  font-weight: 400;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.5);
  line-height: 17px;
  .footer-text-item {
    margin-right: 25px;
    &:last-child {
      margin-right: 0;
    }
  }
  a {
    color: rgba(255, 255, 255, 0.5);
    &:hover {
      color: #fff;
    }
  }
}
</style>
